import React, { useEffect, useState } from 'react';
import { Button, Modal, Form, Input, DatePicker, Descriptions, Image, Space, Table, Typography } from 'antd';
import CustomerPicker from "components/pickers/customer"
import InputNumber from "components/input-number"
import ImagePicker from "components/pickers/image/MultiImagePicker"
import DebtService from "services/debt"
import { useApp } from 'contexts/app';
import dayjs from 'dayjs';
import ComonFields from "./ComonFields"
import { formatDate, formatOnlyDate } from "utils/date"
import { formatCurrency } from "utils/number"
import { ExclamationCircleOutlined } from '@ant-design/icons';
import PaymentAllocation from "./PaymentAllocation"

import _ from "lodash"
const { Title } = Typography;
const service = new DebtService();
const UpdateDebt = ({ onSaved, id, open = false, onClose }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showPaymentAllocation, setShowPaymentAllocation] = useState(false);
    const { modal, showLoading } = useApp();


    const { showNotify } = useApp();
    const [data, setData] = useState({})

    useEffect(() => {
        if (open != isModalOpen) {
            setIsModalOpen(open)
        }
    }, [open])

    useEffect(() => {
        setData({})
        if (isModalOpen && id) {
            loadData();
        }
    }, [isModalOpen, id])
    const deleteDebt = async debtID => {
        showLoading(true);
        await service.delete(debtID);
        showLoading(false);
        onSaved();
    }
    const loadData = async () => {

        var item = await service.getByID(id);

        if (item) {
            setData(item)
            setIsModalOpen(true);
        } else {

            setData({})
        }
    }


    useEffect(() => {
        if (!isModalOpen) {
            if (onClose)
                onClose()
        }
    }, [isModalOpen])

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onBntDeleteClick = async () => {
        modal.confirm({
            icon: <ExclamationCircleOutlined />,
            content: "Bạn chắc chắn muốn xoá thanh toán này",
            onOk: async () => {
                await deleteDebt(id);
                handleCancel();
            },
        })
    }


    const columns = [
        {
            title: 'Đơn hàng',

            render: (record) => {

                return (
                    <Space direction='vertical'>

                        <div>
                            {record.order_id}

                        </div>
                        <div>
                            {formatOnlyDate(record.order.create_on)}
                        </div>
                    </Space>
                )

            }
        },

        {
            title: 'Số tiền',

            render: (record) => {

                return (
                    <Space direction='vertical'>
                        {formatCurrency(record.amount)}


                    </Space>
                )

            }
        },






    ];



    return (
        <>

            <Modal
                title="Chi tiết"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isModalOpen}

                onCancel={handleCancel}
                footer={<Space>
                    <Button danger onClick={onBntDeleteClick}>Delete</Button>
                    <Button type='primary' onClick={e => setShowPaymentAllocation(true)}>Phân bổ</Button>
                    <Button onClick={handleCancel}>Close</Button>
                </Space>}
            >
                <Descriptions column={2} >
                    <Descriptions.Item label="Ngày thanh toán">{formatOnlyDate(data.date)}</Descriptions.Item>
                    <Descriptions.Item label="Số tiền">{formatCurrency(data.amount)}</Descriptions.Item>
                    <Descriptions.Item label="Nội dung" span={2}>{data.description}</Descriptions.Item>

                    <Descriptions.Item label="Hình ảnh" span={2}>
                        <Image.PreviewGroup
                            preview={{
                                onChange: (current, prev) => console.log(`current index: ${current}, prev index: ${prev}`),
                            }}
                        >
                            {_.map(data.images, img => {
                                return (
                                    <Image width={100} src={img.url} />
                                )
                            })}


                        </Image.PreviewGroup>
                    </Descriptions.Item>



                </Descriptions>
                <Space style={{ width: "100%" }} direction='vertical'>
                    <Title level={5}>Phân bổ</Title>
                    <Table pagination={false} columns={columns} dataSource={data.allocations ?? []}></Table>
                </Space>

            </Modal>

            <PaymentAllocation id={id} open={showPaymentAllocation} onClose={e => setShowPaymentAllocation(false)} onSaved ={onSaved}></PaymentAllocation>
        </>
    );
};
export default UpdateDebt;